
import { sendRequest } from './xhr_tools.js';

// @TODO: refactor everywhere that uses this to make this function reside inside xhr_utils
const sendPostRequest = (url, params, onSuccess, onError)=> {
  return sendRequest({
    url,
    params,
    onSuccess,
    onError,
    method: 'POST'
  });
}

export default sendPostRequest